import React from "react";
import { Tooltip } from "@mui/material";
/**
 * Tooltip in the Figma "Tooltip" style: dark 6px-radius bubble, 12/18 text, 8px arrow on top.
 * The bubble colour comes from the theme's Tooltip override.
 */
export const DesignTooltip = ({ title, maxWidth, children, }) => (React.createElement(Tooltip, { title: title, arrow: true, placement: "bottom", enterTouchDelay: 0, slotProps: {
        tooltip: {
            sx: {
                px: "6px",
                py: "3px",
                fontSize: 12,
                lineHeight: "18px",
                fontWeight: 400,
                borderRadius: "6px",
                maxWidth: maxWidth !== null && maxWidth !== void 0 ? maxWidth : "none",
                // A "\n" in a text title starts a new line (e.g. "External Temperature" / "Name: …").
                whiteSpace: "pre-line",
                // Same selector MUI uses for its default 14px gap; the arrow here is only 4px tall.
                '.MuiTooltip-popper[data-popper-placement*="bottom"] &': {
                    marginTop: "8px",
                },
            },
        },
        arrow: { sx: { fontSize: 8 } },
    } }, children));
export default DesignTooltip;
